module.exports = {"320411001":"河海街道","320411002":"三井街道","320411003":"龙虎塘街道","320411100":"春江镇","320411101":"孟河镇","320411102":"新桥镇","320411103":"薛家镇","320411104":"罗溪镇","320411105":"西夏墅镇","320411122":"奔牛镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320411.json
// module id = 861
// module chunks = 0